import { createStore } from 'vuex'
import theme from './theme'

export default createStore({
  modules: {
    theme
  }
})